import { useState, useMemo } from "react"
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Chip,
  TextField,
  InputAdornment,
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Divider,
  Stack,
  CircularProgress,
  Alert,
  FormControl,
  InputLabel,
  Select,
  TableSortLabel,
  Card,
  CardContent,
} from "@mui/material"
import {
  Search as SearchIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Add as AddIcon,
  Close as CloseIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Business as BusinessIcon,
  LocationOn as LocationOnIcon,
  Work as WorkIcon,
  AccountBalance as AccountBalanceIcon,
  CalendarToday as CalendarIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material"
import { useApiQuery, useApiMutation } from "../../hooks/useApi"
import { useNavigate } from "react-router-dom"


///
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
///

const CONSTITUTION_OPTIONS = ["Individual", "Firm", "Company", "LLP", "Other"]
const STATUS_OPTIONS = ["Active", "Inactive"]

function ClientsPage() {

  const navigate = useNavigate()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchTerm, setSearchTerm] = useState("")
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedClient, setSelectedClient] = useState(null)
  const [orderBy, setOrderBy] = useState("createdAt")
  const [order, setOrder] = useState("desc")

  // Dialog states
  const [viewDialogOpen, setViewDialogOpen] = useState(false)
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

  // Edit form state
  const [editFormData, setEditFormData] = useState({})

  const { data: clientsData, isLoading, error, refetch } = useApiQuery(["clients"], "/clients/")
  
  // //console.log("ClientData:", clientsData|| null)

  const { data:{jobs: allClientJobs} = {}, isLoading: jobsLoading } = useApiQuery(
    ["all-client-jobs", selectedClient?._id],
    selectedClient ? `/clients/${selectedClient._id}/jobs` : null,
    { enabled: !!selectedClient }
  )

  const updateClientMutation = useApiMutation(`/clients/${editFormData._id}`, "PATCH", {
    onSuccess: () => {
      refetch("clients")
      handleCloseEditDialog()
    },
  })

  const deleteClientMutation = useApiMutation("/clients", "DELETE", {
    onSuccess: () => {
      refetch()
      handleCloseDeleteDialog()
    },
  })

  const displayClients = clientsData?.clients || []

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc"
    setOrder(isAsc ? "desc" : "asc")
    setOrderBy(property)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number.parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleMenuClick = (event, client) => {
    setAnchorEl(event.currentTarget)
    setSelectedClient(client)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleViewDetails = () => {
    setViewDialogOpen(true)
    handleMenuClose()
  }

  const handleCloseViewDialog = () => {
    setViewDialogOpen(false)
    setSelectedClient(null)
  }

  const handleEditClient = () => {
    setEditFormData({
      _id: selectedClient._id,
      name: selectedClient.name || "",
      phoneNumber: selectedClient.phoneNumber || "",
      panNumber: selectedClient.panNumber || "",
      constitution: selectedClient.constitution || "",
      tradeName: selectedClient.tradeName || "",
      address: selectedClient.address || "",
      gstinNumber: selectedClient.gstinNumber || "",
      status: selectedClient.status || "Active",
    })
    setEditDialogOpen(true)
    handleMenuClose()
  }

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false)
    setEditFormData({})
  }

  const handleDeleteClient = () => {
    setDeleteDialogOpen(true)
    handleMenuClose()
  }

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false)
    setSelectedClient(null)
  }

  const handleEditFormChange = (field, value) => {
    setEditFormData((prev) => ({ ...prev, [field]: value }))
  }

  const handleSaveEdit = async () => {
    try {
      // //console.log('handle Save Edit called with data:', editFormData)
      await updateClientMutation.mutateAsync({data: editFormData})
    } catch (error) {
      console.error("Update failed:", error)
    }
  }

  const handleConfirmDelete = async () => {
    try {
      await deleteClientMutation.mutateAsync({
        url: `/clients/${selectedClient._id}`,
      })
    } catch (error) {
      console.error("Delete failed:", error)
    }
  }

  const formatCurrency = (amount) => {
    const numAmount = Number(amount) || 0
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(numAmount)
  }

  const filteredAndSortedClients = useMemo(() => {
    let filtered = displayClients.filter(
      (client) =>
        client.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.panNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.phoneNumber?.includes(searchTerm)
    )

    filtered.sort((a, b) => {
      let aValue = a[orderBy]
      let bValue = b[orderBy]

      if (orderBy === "createdAt") {
        aValue = new Date(aValue)
        bValue = new Date(bValue)
      } else if (typeof aValue === "string") {
        aValue = aValue.toLowerCase()
        bValue = bValue.toLowerCase()
      }

      if (aValue < bValue) return order === "asc" ? -1 : 1
      if (aValue > bValue) return order === "asc" ? 1 : -1
      return 0
    })

    return filtered
  }, [displayClients, searchTerm, orderBy, order])

  const paginatedClients = useMemo(() => {
    return filteredAndSortedClients.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  }, [filteredAndSortedClients, page, rowsPerPage])





    ///
  const ledgerRef = useRef();
  ///
  const handlePrintLedger = useReactToPrint({
  contentRef: ledgerRef,
  documentTitle: `Client_Ledger_${selectedClient?.name || "Client"}`,
  });
  const handleExportLedgerExcel = () => {
  if (!allClientJobs || allClientJobs.length === 0) return;

  const worksheetData = [
    ["Job ID", "Job Type", "Status", "Fee Status", "Settled By", "Assigned To", "Fees", "Created At"]
  ];

  allClientJobs.forEach(job => {
    worksheetData.push([
      job.JobId,
      job.jobType,
      job.status,
      job.feeStatus,
      job.settledBy,
      job.assignedTo,
      job.fees,
      new Date(job.createdAt).toLocaleString(),
    ]);
  });

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger");

  XLSX.writeFile(workbook, `Client_Ledger_${selectedClient?.name || "Client"}.xlsx`);
  };
  ///





  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress size={60} />
      </Box>
    )
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        Error loading clients: {error.message}
      </Alert>
    )
  }

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Clients
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Manage all your clients in one place
          </Typography>
        </Box>
        <Box>
          <Typography variant="h4" color="primary" sx={{textAlign: "center"}}>
            {displayClients.length}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Total Clients
          </Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <IconButton onClick={refetch} color="primary">
            <RefreshIcon />
          </IconButton>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate("/add-client")}>
            Add New Client
          </Button>
        </Stack>
      </Box>

      {/* Search */}
      <Paper sx={{ mb: 2 }}>
        <Box sx={{ p: 2 }}>
          <TextField
            fullWidth
            placeholder="Search clients by name, email, PAN, or phone..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Paper>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "name"}
                  direction={orderBy === "name" ? order : "asc"}
                  onClick={() => handleRequestSort("name")}
                >
                  Name
                </TableSortLabel>
              </TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>PAN</TableCell>
              <TableCell>Constitution</TableCell>
              <TableCell>New Jobs</TableCell>
              <TableCell>Processing Jobs</TableCell>
              <TableCell>Completed Jobs</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedClients.map((client) => (
              <TableRow key={client._id} hover>
                <TableCell>
                  <Typography variant="subtitle2" fontWeight={600}>
                    {client.name}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {client.tradeName}
                  </Typography>
                </TableCell>
                <TableCell>{client.phoneNumber}</TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                    {client.panNumber}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip label={client.constitution} size="small" variant="outlined" />
                </TableCell>
                <TableCell>
                  <Chip label={client?.newJobCount} size="small" variant="outlined" />
                </TableCell>
                <TableCell>
                  <Chip label={client?.processingJobCount} size="small" variant="outlined" />
                </TableCell>
                <TableCell>
                  <Chip label={client?.completedJobCount} size="small" variant="outlined" />
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={(e) => handleMenuClick(e, client)}>
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {paginatedClients.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                  <Typography variant="h6" color="textSecondary">
                    No clients found
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {searchTerm ? "Try adjusting your search." : "Start by adding your first client."}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={filteredAndSortedClients.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* Actions Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={handleViewDetails}>
          <VisibilityIcon sx={{ mr: 1 }} />
          View Details
        </MenuItem>
        <MenuItem onClick={handleEditClient}>
          <EditIcon sx={{ mr: 1 }} />
          Edit Client
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleDeleteClient} sx={{ color: "error.main" }}>
          <DeleteIcon sx={{ mr: 1 }} />
          Delete Client
        </MenuItem>
      </Menu>

      {/* View Details Dialog */}
      <Dialog open={viewDialogOpen} onClose={handleCloseViewDialog} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" fontWeight="bold">
              Client Details
            </Typography>
            <IconButton onClick={handleCloseViewDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          {selectedClient && (
            <Box>
              {/* Client Information */}
              <Paper sx={{ p: 3, mb: 3, bgcolor: "grey.50" }}>
                <Typography variant="h6" gutterBottom fontWeight={600}>
                  Basic Information
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <Box>
                        <Typography variant="caption" color="textSecondary">
                          Client Name
                        </Typography>
                        <Typography variant="body1" fontWeight={600}>
                          {selectedClient.name}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary">
                          Trade Name
                        </Typography>
                        <Typography variant="body1" fontWeight={600}>
                          {selectedClient.tradeName}
                        </Typography>
                      </Box>
                      <Box>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <PhoneIcon fontSize="small" color="action" />
                          <Box>
                            <Typography variant="caption" color="textSecondary">
                              Phone Number
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                              {selectedClient.phoneNumber}
                            </Typography>
                          </Box>
                        </Stack>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary">
                          PAN Number
                        </Typography>
                        <Typography variant="body1" fontWeight={600} sx={{ fontFamily: "monospace" }}>
                          {selectedClient.panNumber}
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <Box>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <BusinessIcon fontSize="small" color="action" />
                          <Box>
                            <Typography variant="caption" color="textSecondary">
                              Constitution
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                              {selectedClient.constitution}
                            </Typography>
                          </Box>
                        </Stack>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary">
                          GSTIN Number
                        </Typography>
                        <Typography variant="body1" fontWeight={600}>
                          {selectedClient.gstinNumber || "N/A"}
                        </Typography>
                      </Box>
                      <Box>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <AccountBalanceIcon fontSize="small" color="success" />
                          <Box>
                            <Typography variant="caption" color="textSecondary">
                              Current Balance
                            </Typography>
                            <Typography variant="h6" fontWeight="bold" color="success.main">
                              {formatCurrency(selectedClient.balance || 0)}
                            </Typography>
                          </Box>
                        </Stack>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary">
                          Status
                        </Typography>
                        <Box sx={{ mt: 0.5 }}>
                          <Chip
                            label={selectedClient.status || "Active"}
                            color={selectedClient.status === "Active" ? "success" : "default"}
                            size="small"
                          />
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>

                  {selectedClient.address && (
                    <Grid item xs={12}>
                      <Stack direction="row" alignItems="flex-start" spacing={1}>
                        <LocationOnIcon fontSize="small" color="action" />
                        <Box>
                          <Typography variant="caption" color="textSecondary">
                            Address
                          </Typography>
                          <Typography variant="body1">{selectedClient.address}</Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  )}

                  {/* <Grid item xs={12}>
                    <Divider />
                  </Grid> */}

                  {/* <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      Created At
                    </Typography>
                    <Typography variant="body2">
                      {new Date(selectedClient.createdAt).toLocaleString()}
                    </Typography>
                  </Grid> */}
                </Grid>
              </Paper>

              {/* All Client's Jobs */}
              {/* Client Ledger Section */}
              <Paper sx={{ p: 3 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6" fontWeight={600}>
                    Client Jobs ({allClientJobs?.length || 0} jobs)
                  </Typography>

                  {/* <Stack direction="row" spacing={1}>
                    <Button
                      variant="outlined"
                      onClick={handlePrintLedger}
                    >
                      Print PDF
                    </Button>

                    <Button
                      variant="outlined"
                      onClick={handleExportLedgerExcel}
                    >
                      Export Excel
                    </Button>
                  </Stack> */}
                </Box>

                <Divider sx={{ mb: 2 }} />

                <div ref={ledgerRef}>
                  {jobsLoading ? (
                    <Box display="flex" justifyContent="center" py={4}>
                      <CircularProgress />
                    </Box>
                  ) : allClientJobs && allClientJobs.length > 0 ? (
                    <>

                      {/* Pagination state */}
                      {(() => {
                        if (!window._clientLedgerPageState) {
                          window._clientLedgerPageState = { page: 0, rows: 20 };
                        }
                      })()}

                      <TableContainer sx={{ maxHeight: 350 }}>
                        <Table stickyHeader size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell><strong>Job ID</strong></TableCell>
                              <TableCell><strong>Job Type</strong></TableCell>
                              <TableCell><strong>Status</strong></TableCell>
                              <TableCell><strong>Fee Status</strong></TableCell>
                              <TableCell><strong>Settled By</strong></TableCell>
                              <TableCell><strong>Assigned To</strong></TableCell>
                              <TableCell><strong>Fees</strong></TableCell>
                              <TableCell><strong>Created At</strong></TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {allClientJobs
                              .slice(
                                window._clientLedgerPageState.page * window._clientLedgerPageState.rows,
                                window._clientLedgerPageState.page * window._clientLedgerPageState.rows +
                                  window._clientLedgerPageState.rows
                              )
                              .map((job) => (
                                <TableRow key={job.id} hover>
                                  <TableCell>{job.JobId}</TableCell>
                                  <TableCell>{job.jobType}</TableCell>

                                  <TableCell>
                                    <Chip
                                      label={job.status}
                                      size="small"
                                      color={
                                        job.status === "completed"
                                          ? "success"
                                          : job.status === "processing"
                                          ? "primary"
                                          : job.status === "cancelled"
                                          ? "error"
                                          : "default"
                                      }
                                    />
                                  </TableCell>

                                  <TableCell>
                                    <Chip
                                      label={job.feeStatus}
                                      size="small"
                                      color={job.feeStatus === "settled" ? "success" : "warning"}
                                    />
                                  </TableCell>

                                  <TableCell>{job.settledBy}</TableCell>
                                  <TableCell>{job.assignedTo}</TableCell>

                                  <TableCell>{job.fees}</TableCell>

                                  <TableCell>
                                    {new Date(job.createdAt).toLocaleString()}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <TablePagination
                        component="div"
                        rowsPerPageOptions={[20, 30, 40]}
                        count={allClientJobs.length}
                        rowsPerPage={window._clientLedgerPageState.rows}
                        page={window._clientLedgerPageState.page}
                        onPageChange={(e, newPage) => {
                          window._clientLedgerPageState.page = newPage;
                        }}
                        onRowsPerPageChange={(e) => {
                          window._clientLedgerPageState.rows = parseInt(e.target.value, 10);
                          window._clientLedgerPageState.page = 0;
                        }}
                      />
                    </>
                  ) : (
                    <Box textAlign="center" py={4}>
                      <WorkIcon sx={{ fontSize: 60, color: "text.secondary", mb: 2 }} />
                      <Typography variant="h6" color="textSecondary">
                        No jobs to display
                      </Typography>
                    </Box>
                  )}
                </div>
              </Paper>


            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseViewDialog}>Close</Button>
          <Button variant="contained" startIcon={<EditIcon />} onClick={handleEditClient}>
            Edit Client
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={editDialogOpen} onClose={handleCloseEditDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" fontWeight="bold">
              Edit Client
            </Typography>
            <IconButton onClick={handleCloseEditDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Client Name"
                value={editFormData.name || ""}
                onChange={(e) => handleEditFormChange("name", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Trade Name"
                value={editFormData.tradeName || ""}
                onChange={(e) => handleEditFormChange("tradeName", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Phone Number"
                value={editFormData.phoneNumber || ""}
                onChange={(e) => handleEditFormChange("phoneNumber", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="PAN Number"
                value={editFormData.panNumber || ""}
                onChange={(e) => handleEditFormChange("panNumber", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Constitution</InputLabel>
                <Select
                  value={editFormData.constitution || ""}
                  label="Constitution"
                  onChange={(e) => handleEditFormChange("constitution", e.target.value)}
                >
                  {CONSTITUTION_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="GSTIN Number"
                value={editFormData.gstinNumber || ""}
                onChange={(e) => handleEditFormChange("gstinNumber", e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                multiline
                rows={3}
                value={editFormData.address || ""}
                onChange={(e) => handleEditFormChange("address", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={editFormData.status || "Active"}
                  label="Status"
                  onChange={(e) => handleEditFormChange("status", e.target.value)}
                >
                  {STATUS_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseEditDialog} disabled={updateClientMutation.isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveEdit}
            disabled={updateClientMutation.isLoading}
            startIcon={updateClientMutation.isLoading ? <CircularProgress size={20} /> : <EditIcon />}
          >
            {updateClientMutation.isLoading ? "Saving..." : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold" color="error">
            Delete Client
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Alert severity="warning" sx={{ mb: 2 }}>
            This action cannot be undone!
          </Alert>
          <Typography variant="body1">
            Are you sure you want to delete <strong>{selectedClient?.name}</strong>?
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
            All associated data will be permanently removed from the system.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseDeleteDialog} disabled={deleteClientMutation.isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirmDelete}
            disabled={deleteClientMutation.isLoading}
            startIcon={deleteClientMutation.isLoading ? <CircularProgress size={20} /> : <DeleteIcon />}
          >
            {deleteClientMutation.isLoading ? "Deleting..." : "Delete Client"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default ClientsPage